var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Checkbox, Row, Col } from 'antd';
import useDebouncedFunction from 'utils/hooks/useDebouncedFunction';
import { GroupWrap } from '../styled';
import { getAnswersWithValue, getHiddenAnswer, getNormalizeAnswers, getParsedAnswer, getUnblockedAnswers } from '../helpers/surveyHelpers';
import EditableAnswerField from './EditableAnswerField';
var Checkboxes = function (_a) {
    var answers = _a.answers, required = _a.required, setEditValue = _a.setEditValue, form = _a.form, isTicketSurvey = _a.isTicketSurvey;
    var _b = getNormalizeAnswers(answers), allAnswersWithValue = _b.allAnswersWithValue, inheritAnswers = _b.inheritAnswers, nonInheritAnswers = _b.nonInheritAnswers, hiddenAnswers = _b.hiddenAnswers;
    var defaultAnswersIds = allAnswersWithValue.map(function (i) { return i.id; });
    var onSelectAnswer = function (ids) {
        var checkedAnswers = answers.filter(function (i) { return ids.includes(i.id); });
        var nonInheritAndBlocked = nonInheritAnswers.filter(function (i) { return !i.blocked_by_default && i.answer_value; });
        var values = getParsedAnswer(checkedAnswers, true);
        if (nonInheritAndBlocked === null || nonInheritAndBlocked === void 0 ? void 0 : nonInheritAndBlocked.length) {
            values.push.apply(values, getParsedAnswer(nonInheritAndBlocked));
        }
        var hiddenWithValue = getAnswersWithValue(hiddenAnswers);
        if (hiddenWithValue === null || hiddenWithValue === void 0 ? void 0 : hiddenWithValue.length) {
            values.push.apply(values, getParsedAnswer(getUnblockedAnswers(checkedAnswers, hiddenWithValue)));
        }
        setEditValue(values);
    };
    var onInputChange = function (answerId, value) { return __awaiter(void 0, void 0, void 0, function () {
        var others, parsedOthers, updatedValues, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, form.validateFields([answerId])];
                case 1:
                    _a.sent();
                    others = allAnswersWithValue.filter(function (i) { return i.id !== answerId; });
                    parsedOthers = getParsedAnswer(others);
                    updatedValues = value
                        ? __spreadArray(__spreadArray([], parsedOthers, true), [{ id: answerId, user_answer_value: value }], false) : parsedOthers;
                    setEditValue(updatedValues);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Validation failed', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onInputDebounce = useDebouncedFunction(onInputChange, 500);
    return (_jsxs(GroupWrap, { children: [_jsx(Checkbox.Group, { defaultValue: defaultAnswersIds, onChange: onSelectAnswer, children: _jsx(Row, { gutter: [0, 8], children: inheritAnswers.map(function (_a) {
                        var id = _a.id, title = _a.title;
                        return (_jsx(Col, { span: 12, children: _jsx(Checkbox, { value: id, children: title }) }, id));
                    }) }) }), nonInheritAnswers.map(function (answer) { return (_jsx(EditableAnswerField, { required: required, kind: answer.kind, answer: answer, onInputChange: function (v) { return onInputDebounce(answer.id, v); }, isHidden: getHiddenAnswer(answer, answers), isTicketSurvey: isTicketSurvey }, answer.id)); })] }));
};
export default Checkboxes;
